import { render, staticRenderFns } from "./WeeklyLeaderBoardOtherTopic.vue?vue&type=template&id=49813fa2&scoped=true&"
import script from "./WeeklyLeaderBoardOtherTopic.vue?vue&type=script&lang=js&"
export * from "./WeeklyLeaderBoardOtherTopic.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyLeaderBoardOtherTopic.vue?vue&type=style&index=0&id=49813fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49813fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
